export default {
  heroEyebrow: 'Решения для команд',
  heroTitle: 'Цифровые сотрудники под процессы вашей команды',
  heroBody:
    'Laplace помогает найти повторяемую работу, создать управляемых AI-агентов с нужным контекстом и инструментами и встроить их в ежедневные процессы.',
  heroImageAlt:
    'Выбор цифрового сотрудника Laplace: анализатор документов, агент документации, планировщик спринта и аналитик задач',

  departmentSalesTitle: 'Продажи',
  departmentSalesBody:
    'Собирать контекст по сделке, готовить материалы к встрече и предлагать следующий шаг.',
  departmentSupportTitle: 'Поддержка',
  departmentSupportBody:
    'Находить подтверждённые ответы, готовить решение и передавать человеку нестандартные обращения.',
  departmentMarketingTitle: 'Маркетинг и контент',
  departmentMarketingBody:
    'Собирать материалы из задач и документов, готовить брифы и черновики в контексте бренда.',
  departmentEngineeringTitle: 'Разработка',
  departmentEngineeringBody:
    'Проверять готовность релиза, находить блокеры и связывать задачи, документацию и изменения кода.',
  departmentDataTitle: 'Данные и аналитика',
  departmentDataBody:
    'Собирать определения и выводы из доступных отчётов и документов со ссылками на источники.',
  departmentKnowledgeTitle: 'База знаний',
  departmentKnowledgeBody:
    'Отвечать по корпоративным документам, объяснять контекст под роль сотрудника и показывать источники.',
  departmentItTitle: 'IT',
  departmentItBody:
    'Разбирать типовые запросы, находить инструкции и готовить разрешённые действия для проверки.',
  departmentLegalTitle: 'Юристы',
  departmentLegalBody:
    'Находить нужные положения в договорах и политиках и готовить материалы для проверки специалистом.',
  departmentPeopleTitle: 'HR и People',
  departmentPeopleBody:
    'Сопровождать онбординг, отвечать по внутренним правилам и готовить повторяемые HR-операции.',
  departmentProductivityTitle: 'Операции',
  departmentProductivityBody:
    'Запускать повторяемые задачи по расписанию, собирать результат и передавать исключения человеку.',

  exampleEyebrow: 'Сценарий · Разработка',
  exampleTitle: 'Цифровой сотрудник координирует готовность релиза',
  exampleBody:
    'По запросу или расписанию агент собирает статусы из Jira, Confluence и GitHub, показывает блокеры и подтверждает выводы ссылками на источники.',
  exampleAsksLabel: 'Сотрудник спрашивает',
  exampleQuestion: 'Проверь готовность релиза и покажи блокеры',
  exampleAnswersLabel: 'Laplace отвечает',
  exampleAnswer:
    'Релиз близок к готовности. Нашёл 3 пункта, которые требуют внимания:',
  exampleTask1Key: 'LP-216',
  exampleTask1Title: 'Критичный баг остаётся в работе',
  exampleTask2Key: 'DOC',
  exampleTask2Title: 'Документация релиза не обновлена',
  exampleTask3Key: 'PR #184',
  exampleTask3Title: 'Изменения ожидают ревью',
  exampleSource: 'Jira · Confluence · GitHub',

  faqEyebrow: 'Частые вопросы',
  faqTitle: 'Что это даёт и чем отличается от привычного AI-чата',

  faqVsChatQuestion: 'Чем это отличается от ChatGPT или Claude?',
  faqVsChatAnswer:
    'Чат отвечает на то, что вы принесли ему в диалог. Laplace работает внутри ваших систем: сам находит нужное в Jira, Confluence, GitHub и почте и может выполнить там действие — завести задачу, обновить страницу, отправить письмо. Каждое изменение проходит подтверждение, и по каждому остаётся запись.',

  faqAlreadyHaveChatQuestion:
    'У нас уже есть корпоративный AI-чат. Зачем ещё инструмент?',
  faqAlreadyHaveChatAnswer:
    'Чат живёт для одного человека и начинает каждый разговор с чистого листа. Laplace настраивается на воркспейс: администратор подключает источники один раз, и вся команда работает с одним контекстом. Что сделал агент, видно в общем журнале, а не остаётся в личной переписке сотрудника.',

  faqWritesQuestion: 'Что агент может изменить в наших системах?',
  faqWritesAnswer:
    'Читать он может свободно — искать задачи, документы, обсуждения. Всё, что меняет данные, устроено иначе: создание задачи, правка страницы, смена статуса и отправка письма требуют подтверждения. Вы видите, что именно будет сделано, до того как это произойдёт, и можете отклонить.',

  faqAccessQuestion: 'Как ограничить, к чему у агента есть доступ?',
  faqAccessAnswer:
    'Агент видит только те системы, которые администратор подключил к воркспейсу. Неподключённый источник для него не существует, и он не может сослаться на данные, к которым у него нет доступа. Роли определяют, кто настраивает интеграции и запускает агентов.',

  faqDataQuestion: 'Где обрабатываются наши данные?',
  faqDataAnswer:
    'Действия в ваших внутренних системах можно выполнять через Private Connector: он ставится в вашем контуре и сам подключается наружу, поэтому открывать входящие порты не нужно. Обработка запросов языковой моделью происходит на стороне провайдера модели. Точную схему под ваши требования разберём на демо.',

  faqStartQuestion: 'С чего начать внедрение?',
  faqStartAnswer:
    'С одного процесса. На демо разбираем, какая повторяемая работа отнимает у команды больше всего времени, что нужно подключить и как ограничить роль агента, и запускаем один измеримый сценарий.',

  ctaTitle: 'Найдём первый процесс для цифрового сотрудника',
  ctaBody:
    'Покажем, как подключить ваши системы, ограничить роль агента и запустить измеримый сценарий.',
  ctaButton: 'Запросить демо',
}
